import { ApplicationSummary } from "components/ApplicationSummary/ApplicationSummary";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Store } from "state/store";
import {
  EXTEND_TERM_ENTRY_URL,
  LANDING_URL,
  REPAYMENT_HOLIDAY_ENTRY_URL,
  THANK_YOU_URL,
} from "App.const";
import { Col } from "reactstrap";
import { PageKit } from "components/common/PageContainer/PageKit";
import { Menu, TreatmentOptions } from "domain/menuOptions";
import { APPLICATION_SUMMARY_SCREEN_TITLE } from "./Title.const";

type ApplicationSummaryScreenProps = {
  store: Store;
  treatmentOption: TreatmentOptions;
};
const ApplicationSummaryScreen = ({
  store,
  treatmentOption,
}: ApplicationSummaryScreenProps) => {
  document.title = APPLICATION_SUMMARY_SCREEN_TITLE;
  const navigate = useNavigate();

  const menuStore = store.menuStore;
  const loanInfo = store.aboutYourLoanStore.data;
  const existingLoanDetails =
    store.indicativeRepaymentOptionsStore.existingLoanDetails;

  const loanDetails = { ...loanInfo, ...existingLoanDetails };
  const selectedTreatment = store.selectedTreatmentStore.selectedTreatments;

  const selectedTreatmentPayload = store.selectedTreatmentPayload;

  const handleSubmit = async () => {
    await store.selectedTreatmentPostStore.postSelectedTreatments(
      selectedTreatmentPayload
    );
    navigate(THANK_YOU_URL, { replace: true });
  };

  const handleEdit = () => {
    switch (treatmentOption) {
      case Menu.ExtendTerm:
        return navigate(EXTEND_TERM_ENTRY_URL, { replace: true });
      case Menu.RequestRepaymentHoliday:
        return navigate(REPAYMENT_HOLIDAY_ENTRY_URL, { replace: true });
      default:
        navigate(LANDING_URL, { replace: true });
    }
  };

  return (
    <>
      <PageKit
        selectedMenu={
          store.selectedTreatmentStore.selectedTreatments.treatmentOptionType
        }
        menus={menuStore.data}
      />
      <Col className="content-body request-repayment-summary">
        <ApplicationSummary
          loanDetails={loanDetails}
          selectedTreatment={selectedTreatment}
          onSubmit={handleSubmit}
          onEdit={handleEdit}
        />
      </Col>
    </>
  );
};

const ApplicationSummaryScreenObserver = observer(ApplicationSummaryScreen);
export { ApplicationSummaryScreenObserver as ApplicationSummaryScreen };
